export default [
  {
    path: "/error-404",
    name: "error-404",
    component: () => import("@/views/error/Error404.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/login",
    name: "auth-login",
    component: () => import("@/views/pages/authentication/Login.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  {
    path: "/login-forgot/:email/:password",
    name: "auth-login-forgot",
    component: () => import("@/views/pages/authentication/Login.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  {
    path: "/no-autorizado",
    name: "misc-not-authorized",
    component: () =>
      import("@/views/pages/miscellaneous/NotAuthorized.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/pages/miscellaneous/under-maintenance",
    name: "misc-under-maintenance",
    component: () =>
      import("@/views/pages/miscellaneous/UnderMaintenance.vue"),
    meta: {
      layout: "full",
    },
  },
  {
    path: "/pages/miscellaneous/error",
    name: "misc-error",
    component: () => import("@/views/pages/miscellaneous/Error.vue"),
    meta: {
      layout: "full",
    },
  },
  {
    path: "/perfil",
    name: "perfil",
    component: () =>
      import("@/views/pages/account-setting/AccountSetting.vue"),
    meta: {
      pageTitle: "Perfil",
      breadcrumb: [
        {
          text: "Usuarios",
        },
      ],
      resource: "Profile",
      action: "read",
    },
  },
  {
    path: "/pages/profile",
    name: "pages-profile",
    component: () => import("@/views/pages/profile/Profile.vue"),
    meta: {
      pageTitle: "Profile",
      breadcrumb: [
        {
          text: "Pages",
        },
        {
          text: "Profile",
          active: true,
        },
      ],
    },
  },
  {
    path: "/auth/magic-link-sent/:email?",
    name: "magic-link-sent",
    component: () => import("@/views/pages/authentication/MagicLinkSent.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  {
    path: "/auth/verify-magic-link/:token",
    name: "verify-magic-link",
    component: () => import("@/views/pages/authentication/VerifyMagicLink.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: false, // Permitir acceso aún si está logueado para manejar el token
    },
  },
]
